module.exports = __webpack_public_path__ + "img/stock_icon.bdb8139f.png";